// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2O4qK","error":"Textarea_error__2Jm0-","readonly":"Textarea_readonly__1a6Xr","disabled":"Textarea_disabled__AjCud"};